import PropTypes from 'prop-types';
import { Fade, makeStyles } from '@material-ui/core';
import SurveyGroup from './surveyGroup';
import CustomButton from '../customButton';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  loadMoreWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: spacing(4),
    width: '100%',
  },
  loadMoreButton: {
    border: `1px solid ${primary.bluish3}`,
    borderRadius: 44,
    color: primary.bluish4,
    lineHeight: '24px',
    justifySelf: 'center',
    padding: spacing(1, 4),
    maxHeight: 32,
  },
}));

const SurveyGroups = ({
  translations,
  groups,
  surveyColumns,
  hasLoadMore,
  canManageAllSurveys,
  onEditGroupTitle,
  onDeleteGroup,
  onDuplicateGroup,
  onLoadMore,
  onCreateSurvey,
  onReorderGroupItems,
}) => {
  const classes = useStyles();

  return (
    <div>
      {groups.map(group => (
        <SurveyGroup
          key={`survey_group_${group.title}`}
          id={group.id}
          translations={translations}
          group={group}
          surveyColumns={surveyColumns}
          canManageAllSurveys={canManageAllSurveys}
          onEditTitle={onEditGroupTitle}
          onDelete={onDeleteGroup}
          onDuplicate={onDuplicateGroup}
          onCreateSurvey={onCreateSurvey}
          onReorder={onReorderGroupItems}
        />
      ))}
      <Fade in={hasLoadMore} unmountOnExit>
        <div className={classes.loadMoreWrapper}>
          <CustomButton
            className={classes.loadMoreButton}
            type="addWithTextRounded"
            onClick={onLoadMore}
          >
            {translations.loadMoreButton}
          </CustomButton>
        </div>
      </Fade>
    </div>
  );
};

SurveyGroups.propTypes = {
  translations: PropTypes.object.isRequired,
  hasLoadMore: PropTypes.bool.isRequired,
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
  surveyColumns: PropTypes.arrayOf(PropTypes.object).isRequired,
  canManageAllSurveys: PropTypes.bool.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  onCreateSurvey: PropTypes.func.isRequired,
  onEditGroupTitle: PropTypes.func.isRequired,
  onDeleteGroup: PropTypes.func.isRequired,
  onDuplicateGroup: PropTypes.func.isRequired,
  onReorderGroupItems: PropTypes.func.isRequired,
};

export default SurveyGroups;
